import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  diolagContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },

  diolagHeader: {
    width: '100%',
    '& > h2': {
      fontSize: 16,
      fontWeight: 500,
      color: theme.palette.background.primary.contrastText,
      textAlign: 'center',
      margin: '8px 16px 32px 16px',
    },

  },

  diolagButtonContainer: {
    width: '80%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  title: {
    fontSize: 15,
    fontWeight: 500,
    marginBottom: 8,
    color: theme.palette.background.primary.main,
  },

  diolageButton: {
    width: 132,
    background: '#fff',
    border: `2px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  diolageButtonNo: {
    width: 132,
  },
}))
